import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { getDateFormatted, getTimeFormatted12Hours } from '@/services/date'
import { mdiCalendarCheckOutline, mdiClockOutline } from '@mdi/js'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventDateTime',
  props: {
    eventData: null
  },
  setup(__props: any) {

const props = __props as {
  eventData: IEventEdit
};



const dateStart = ref(getDateFormatted(props.eventData.dateStart).slice(0, 10) || '')
const dateEnd = ref(getDateFormatted(props.eventData.dateEnd).slice(0, 10) || '')
const timeStart = ref(getTimeFormatted12Hours(props.eventData.dateStart) || '12:00')
const timeEnd = ref(getTimeFormatted12Hours(props.eventData.dateEnd) || '12:00')

return { __sfc: true,props, dateStart, dateEnd, timeStart, timeEnd, mdiCalendarCheckOutline, mdiClockOutline }
}

})